// package: address
// file: address/model.proto


export const Address = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.receiver != null) {
            if (object.receiver !== "") {
                message.receiver = String(object.receiver);
            }
        }
        if (object.phone != null) {
            if (object.phone !== "") {
                message.phone = String(object.phone);
            }
        }
        if (object.districtCode != null) {
            if (object.districtCode !== "") {
                message.districtCode = String(object.districtCode);
            }
        }
        if (object.districtName != null) {
            if (object.districtName !== "") {
                message.districtName = String(object.districtName);
            }
        }
        if (object.cityCode != null) {
            if (object.cityCode !== "") {
                message.cityCode = String(object.cityCode);
            }
        }
        if (object.cityName != null) {
            if (object.cityName !== "") {
                message.cityName = String(object.cityName);
            }
        }
        if (object.provinceCode != null) {
            if (object.provinceCode !== "") {
                message.provinceCode = String(object.provinceCode);
            }
        }
        if (object.provinceName != null) {
            if (object.provinceName !== "") {
                message.provinceName = String(object.provinceName);
            }
        }
        if (object.detail != null) {
            if (object.detail !== "") {
                message.detail = String(object.detail);
            }
        }
        if (object.isDefault != null) {
            if (object.isDefault !== false) {
                message.isDefault = Boolean(object.isDefault);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            receiver: "",
            phone: "",
            districtCode: "",
            districtName: "",
            cityCode: "",
            cityName: "",
            provinceCode: "",
            provinceName: "",
            detail: "",
            isDefault: false,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.receiver != null) {
            object.receiver = message.receiver;
        }
        if (message.phone != null) {
            object.phone = message.phone;
        }
        if (message.districtCode != null) {
            object.districtCode = message.districtCode;
        }
        if (message.districtName != null) {
            object.districtName = message.districtName;
        }
        if (message.cityCode != null) {
            object.cityCode = message.cityCode;
        }
        if (message.cityName != null) {
            object.cityName = message.cityName;
        }
        if (message.provinceCode != null) {
            object.provinceCode = message.provinceCode;
        }
        if (message.provinceName != null) {
            object.provinceName = message.provinceName;
        }
        if (message.detail != null) {
            object.detail = message.detail;
        }
        if (message.isDefault != null) {
            object.isDefault = message.isDefault;
        }
        return object;
    },
};

export const TrackingDetail = {
    encode(object) {
        const message = {};
        if (object.time != null) {
            if (object.time !== "") {
                message.time = String(object.time);
            }
        }
        if (object.title != null) {
            if (object.title !== "") {
                message.title = String(object.title);
            }
        }
        if (object.desc != null) {
            if (object.desc !== "") {
                message.desc = String(object.desc);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            time: "",
            title: "",
            desc: "",
        };

        if (message.time != null) {
            object.time = message.time;
        }
        if (message.title != null) {
            object.title = message.title;
        }
        if (message.desc != null) {
            object.desc = message.desc;
        }
        return object;
    },
};

export const Logistic = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.orderID != null) {
            if (object.orderID !== "") {
                message.orderID = String(object.orderID);
            }
        }
        if (object.tradeID != null) {
            if (object.tradeID !== "") {
                message.tradeID = String(object.tradeID);
            }
        }
        if (object.expressID != null) {
            if (object.expressID !== "") {
                message.expressID = String(object.expressID);
            }
        }
        if (object.expressName != null) {
            if (object.expressName !== "") {
                message.expressName = String(object.expressName);
            }
        }
        if (object.expressTel != null) {
            if (object.expressTel !== "") {
                message.expressTel = String(object.expressTel);
            }
        }
        if (object.itemID != null) {
            if (object.itemID !== "") {
                message.itemID = String(object.itemID);
            }
        }
        if (object.itemImageURL != null) {
            if (object.itemImageURL !== "") {
                message.itemImageURL = String(object.itemImageURL);
            }
        }
        if (object.receiverAddress != null) {
            if (object.receiverAddress !== "") {
                message.receiverAddress = String(object.receiverAddress);
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.list != null) {
            if (!Array.isArray(object.list)) {
                throw TypeError("list: array expected");
            }
            if (object.list.length > 0) {
                message.list = [];
                for (let i = 0; i < object.list.length; ++i) {
                    message.list[i] = TrackingDetail.encode(object.list[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            orderID: "",
            tradeID: "",
            expressID: "",
            expressName: "",
            expressTel: "",
            itemID: "",
            itemImageURL: "",
            receiverAddress: "",
            status: 0,
            list: [],
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.orderID != null) {
            object.orderID = message.orderID;
        }
        if (message.tradeID != null) {
            object.tradeID = message.tradeID;
        }
        if (message.expressID != null) {
            object.expressID = message.expressID;
        }
        if (message.expressName != null) {
            object.expressName = message.expressName;
        }
        if (message.expressTel != null) {
            object.expressTel = message.expressTel;
        }
        if (message.itemID != null) {
            object.itemID = message.itemID;
        }
        if (message.itemImageURL != null) {
            object.itemImageURL = message.itemImageURL;
        }
        if (message.receiverAddress != null) {
            object.receiverAddress = message.receiverAddress;
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.list != null) {
            object.list = [];
            for (let i = 0; i < message.list.length; ++i) {
                object.list[i] = TrackingDetail.decode(message.list[i]);
            }
        }
        return object;
    },
};

export const Area = {
    encode(object) {
        const message = {};
        if (object.code != null) {
            if (object.code !== "") {
                message.code = String(object.code);
            }
        }
        if (object.name != null) {
            if (object.name !== "") {
                message.name = String(object.name);
            }
        }
        if (object.level != null) {
            if (object.level !== 0) {
                message.level = object.level;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            code: "",
            name: "",
            level: 0,
        };

        if (message.code != null) {
            object.code = message.code;
        }
        if (message.name != null) {
            object.name = message.name;
        }
        if (message.level != null) {
            object.level = message.level;
        }
        return object;
    },
};

export const Areas = {
    encode(object) {
        const message = {};
        if (object.list != null) {
            if (!Array.isArray(object.list)) {
                throw TypeError("list: array expected");
            }
            if (object.list.length > 0) {
                message.list = [];
                for (let i = 0; i < object.list.length; ++i) {
                    message.list[i] = Area.encode(object.list[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            list: [],
        };

        if (message.list != null) {
            object.list = [];
            for (let i = 0; i < message.list.length; ++i) {
                object.list[i] = Area.decode(message.list[i]);
            }
        }
        return object;
    },
};

export const AreaDetail = {
    encode(object) {
        const message = {};
        if (object.area != null) {
            message.area = Area.encode(object.area);
        }
        if (object.parent != null) {
            message.parent = AreaDetail.encode(object.parent);
        }
        return message;
    },

    decode(message) {
        const object = {
            area: null,
            parent: null,
        };

        if (message.area != null) {
            object.area = Area.decode(message.area);
        }
        if (message.parent != null) {
            object.parent = AreaDetail.decode(message.parent);
        }
        return object;
    },
};


export const Platform = {
    PLATFORM_UNDEFINED: 0,
    PLATFORM_MENGTUI: 1,
};


export const LogisticStatus = {
    LOGISTIC_STATUS_UNDEFINED: 0,
    LOGISTIC_STATUS_ON_THE_WAY: 1,
    LOGISTIC_STATUS_ALREADY_COLLECTED: 2,
    LOGISTIC_STATUS_PUZZLE: 3,
    LOGISTIC_STATUS_ALREADY_SIGNED: 4,
    LOGISTIC_STATUS_ALREADY_BACKED: 5,
    LOGISTIC_STATUS_ALREADY_DELIVERED: 6,
    LOGISTIC_STATUS_ALREADY_SEND_BACKED: 7,
};


export const AreaLevel = {
    AREA_LEVEL_UNDEFINED: 0,
    AREA_LEVEL_PROVINCE: 1,
    AREA_LEVEL_CITY: 2,
    AREA_LEVEL_DISTRICT: 3,
    AREA_LEVEL_TOWN: 4,
};


